import React, {useEffect} from 'react';
import {SeriesCharacterInfo} from "../../models/interfaces/series.interface.ts";
import {SeriesModalAction} from "../../reducers/seriesModalReducer.ts";
import SeriesCharacter from "./SeriesCharacter.tsx";
import {CharacterGender} from "../../models/types/charecterGender.ts";

interface SeriesModalCharactersTabProps {
  seriesCharacters: SeriesCharacterInfo[];
  dispatch: React.ActionDispatch<[action: SeriesModalAction]>
}

const SeriesModalCharactersTab: React.FC<SeriesModalCharactersTabProps> = (
  {
    seriesCharacters,
    dispatch
  }: SeriesModalCharactersTabProps) => {
  const [openCharacters, setOpenCharacters] = React.useState<Record<string, boolean>>({});

  const onCharacterClick = (characterId: string) => {
    setOpenCharacters(prev => ({
      ...prev,
      [characterId]: !prev[characterId]
    }))
  }

  const addNewCharacter = () => {
    dispatch({
      type: "ADD_NEW_CHARACTER"
    });
    setOpenCharacters(prev => ({
      ...prev,
      [seriesCharacters[seriesCharacters.length - 1]?.characterId]: false
    }));
  }

  const deleteCharacter = (characterId: string) => {
    dispatch({
      type: "DELETE_CHARACTER",
      payload: {characterId}
    });
    setOpenCharacters(prev => {
      const newState = {...prev};
      delete newState[characterId];
      return newState;
    });
  }

  const editNameGenderAge = (characterId: string, value: string | CharacterGender, field: "name" | "gender" | "ageRange"): void => {
    switch (field) {
      case "name":
        dispatch({
          type: "EDIT_CHARACTER_NAME",
          payload: {characterId: characterId, newName: value as string}
        });
        break;
      case "gender":
        dispatch({
          type: "EDIT_CHARACTER_GENDER",
          payload: {characterId: characterId, gender: value as CharacterGender}
        });
        break;
      case "ageRange":
        dispatch({
          type: "EDIT_CHARACTER_AGE_RANGE",
          payload: {characterId: characterId, ageRange: value as string}
        });
        break;
    }
  }

  const setOtherNames = (characterId: string, otherNames: string[]): void => {
    dispatch({
      type: "SET_CHARACTER_OTHER_NAME",
      payload: {characterId, otherNames}
    });
  }


  return (
    <div>
      <div className="flex items-center justify-between w-full">
        <div className="h4">Characters</div>
        <div
          className="p-2 text-sm border border-n-400 rounded-xl hover:border-brandPurple-500 hover:text-brandPurple-500 cursor-pointer active:scale-95 transition-transform"
          onClick={addNewCharacter}
        >
          + Add Character
        </div>
      </div>
      <div className="max-h-[500px] overflow-y-auto pr-4 mt-4">
        {seriesCharacters.map((character: SeriesCharacterInfo, index: number) => (
          <SeriesCharacter
            key={character.characterId}
            character={character}
            isOpen={openCharacters[character.characterId]}
            onCharacterClick={(characterId: string) => onCharacterClick(characterId)}
            characterIndex={index}
            deleteCharacter={deleteCharacter}
            editNameGenderAge={editNameGenderAge}
            setOtherNames={setOtherNames}
          />
        ))}
      </div>
    </div>
  )
}

export default SeriesModalCharactersTab;